import { useState } from 'react';
import {
  Avatar,
  Box,
  Chip,
  ClickAwayListener,
  LinearProgress,
  Paper,
  Popper,
  Skeleton,
  Typography,
} from '@mui/material';
import { InfoOutlined, WarehouseOutlined } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import { CustomPagination } from 'utils/functions';
import Blank from 'assets/blank.png';
import localeText from 'utils/localeText';
import styles from './styles';

const InfosProduto = ({ produto, loading }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const rows = (produto?.saldo_detalhado || [])?.map((m) => ({
    ...m,
    uuid: `${m?.validade || '_'}${m?.variacao_id || '_'}${m?.rastreabilidade || '_'}`,
  }));

  const handleChipPress = (event) => setAnchorEl(event.currentTarget);

  const Line = ({ label = '', value }) => (
    <Box display="flex" alignItems="center" gap={2}>
      <Typography variant="body2" fontWeight="bold" flex={1}>
        {label}:
      </Typography>
      <Typography variant="body2" flex={3}>
        {value || '-'}
      </Typography>
    </Box>
  );

  return (
    <Box display="flex" gap={2}>
      <Avatar
        variant="rounded"
        sx={styles?.image}
        src={produto?.imagem || Blank}
      />
      {loading && (
        <Box flex={1} gap={0.5} flexDirection="column">
          <Skeleton variant="text" width="100%" height={32} />
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="50%" />
          <Skeleton
            variant="rounded"
            width={120}
            height={28}
            sx={styles?.chip}
          />
        </Box>
      )}
      <Box
        flex={1}
        gap={0.5}
        flexDirection="column"
        display={produto && !loading ? 'flex' : 'none'}
      >
        <Typography mb={0.5} variant="h6" color="primary" fontWeight="bold">
          {produto?.descricao || ''}
        </Typography>
        <Line label="Referência" value={produto?.referencia} />
        <Line label="Localizador" value={produto?.localizador} />
        <Chip
          color="primary"
          sx={styles?.chip}
          onDelete={handleChipPress}
          icon={<WarehouseOutlined fontSize="small" />}
          deleteIcon={<InfoOutlined fontSize="small" />}
          label={`${produto?.saldo || 0} ${produto?.UnidadeMedida?.sigla || ''}`}
        />
      </Box>
      <Popper
        anchorEl={anchorEl}
        sx={styles?.popper}
        placement="right-end"
        open={Boolean(anchorEl)}
        modifiers={[{ name: 'offset', options: { offset: [0, 15] } }]}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Paper elevation={5} sx={styles?.paper}>
            <Box mb={2}>
              <Typography variant="h6" fontWeight="bold">
                Detalhes do Saldo
              </Typography>
              <Typography variant="caption">{produto?.descricao}</Typography>
            </Box>
            <Box flex={1}>
              <DataGrid
                rows={rows}
                columns={[
                  {
                    field: 'rastreabilidade',
                    headerName: 'Rastreabilidade',
                    minWidth: 200,
                    flex: 1,
                    sortable: false,
                  },
                  {
                    field: 'variacao',
                    headerName: 'Variação',
                    minWidth: 200,
                    flex: 1,
                    sortable: false,
                  },
                  {
                    field: 'validade',
                    headerName: 'Validade',
                    minWidth: 200,
                    flex: 1,
                    sortable: false,
                    valueGetter: ({ value }) =>
                      value && moment(value).format('DD/MM/YYYY'),
                  },
                  {
                    field: 'saldo',
                    headerName: 'Saldo',
                    type: 'number',
                    minWidth: 200,
                    flex: 1,
                    sortable: false,
                    valueGetter: ({ value }) =>
                      `${value || 0} ${produto?.UnidadeMedida?.sigla || ''}`,
                  },
                ]}
                pagination
                density="compact"
                disableColumnMenu
                showCellRightBorder
                showColumnRightBorder
                disableSelectionOnClick
                getRowId={(row) => row.uuid}
                localeText={localeText}
                loading={loading}
                components={{
                  LoadingOverlay: LinearProgress,
                  Pagination: CustomPagination,
                }}
              />
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default InfosProduto;
